import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function AssignSubjectForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [clearRows, setClearRows] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sectionsData, setSectionsData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      centerId: "",
    },
  });

  const [selectedCenterId, setSelectedCenterId] = useState(
    savedCenterId || null
  );
  const [subjectsData, setsubjectsData] = useState([]);
  const [selectedClassIds, setselectedClassIds] = useState([]);
  const [selectedSubjectIds, setselectedSubjectIds] = useState([]);
  const [subjectSelectError, setsubjectSelectError] = useState("");
  const [centersData, setCentersData] = useState([]);
  const [classesData, setClassesData] = useState([]);

  const getAllsubjectsList = async (classSectionId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Subject/GetAllSubject?centerId=${selectedCenterId}&classSectionId=${classSectionId.value}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setsubjectsData(response.subjects);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);
        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, [setValue, triggerRerender, savedCenterId]);

  const fetchClassesByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const getsectionData = async (centerClassId) => {
    console.log(centerClassId);
    try {
      const sectionsResponse = await get(
        `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${centerClassId.value}&centerId=${selectedCenterId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSectionsData(sectionsResponse);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    if (selectedCenterId) {
      fetchClassesByCenterId(selectedCenterId);
    }
  }, [selectedCenterId]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: true,
    },
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      // width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
  ];

  const onClassSelect = (ClassId) => {
    setselectedClassIds(ClassId.value);
    setValue("sectionId", null);
    getsectionData(ClassId);
  };
  const onSectionSelect = (classSectionId) => {
    getAllsubjectsList(classSectionId);
  };

  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => ({
      id: row.id,
      status: true,
    }));

    const unselectedRows = subjectsData
      .filter(
        (row) => !state.selectedRows.some((selected) => selected.id === row.id)
      )
      .map((row) => ({
        id: row.id,
        status: false,
      }));

    // Combine selected and unselected rows
    setselectedSubjectIds([...selectedRows, ...unselectedRows]);
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (selectedSubjectIds.length === 0) {
      setsubjectSelectError("Please select at least one class.");
      return;
    } else {
      setsubjectSelectError("");
    }

    const formData = {
      createdBy: localStorage.getItem("userId"),
      classSectionId: getValues("sectionId")?.value,
      subjectIds: selectedSubjectIds,
    };
    try {
      const response = await post("Subject/SaveClassSubject", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        setTriggerRerender((prev) => !prev);
        getAllsubjectsList(selectedClassIds);
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Subjects to Class</h2>
      </div>

      <form
        className="row g-3 new-form-style"
        onSubmit={handleSubmit(saveData)}
      >
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        // isDisabled={!!savedCenterId}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("centerId", null);
                            setValue("centerClassId", null);
                            setClassesData([]);
                            setSelectedCenterId(null);
                          } else {
                            setValue("centerId", selectedOption);
                            setValue("centerClassId", null);
                            setSelectedCenterId(selectedOption.value);

                            fetchClassesByCenterId(selectedOption.value);
                          }
                          trigger("centerId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={
                          savedCenterId !== null && savedCenterId !== 0
                        }
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Class<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerClassId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("centerClassId", null);
                          } else {
                            setValue("centerClassId", selectedOption);
                            onClassSelect(selectedOption);
                            // getAllsubjectsList(selectedOption.value);
                          }
                          trigger("centerClassId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Section<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="sectionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={sectionsData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("sectionId", null);
                          } else {
                            setValue("sectionId", selectedOption);
                            onSectionSelect(selectedOption);
                            // getAllsubjectsList(selectedOption.value);
                          }
                          trigger("section");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Subjects<span className="text-danger fs-9">*</span>
                  </label>

                  <small className="text-danger">{subjectSelectError}</small>

                  <DataTable
                    columns={columns}
                    data={subjectsData}
                    pagination
                    dense
                    customStyles={customTableStyles}
                    // onRowClicked={handleRowClick}
                    highlightOnHover={true}
                    // pointerOnHover={true}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={clearRows}
                    onChangePage={setCurrentPage}
                    onChangeRowsPerPage={setRowsPerPage}
                    selectableRowSelected={useMemo(
                      () => (row) => row.status === true, // Automatically check rows with status 1
                      [subjectsData]
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default AssignSubjectForm;
